export function isAllowToDoAction(me: any, permission: string) {
  return me?.role !== "CUSTOM" || me?.permissions.includes(permission);
}
